"use client";

import { c as _c } from "react/compiler-runtime";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
import { ArrowTopRightOnSquareIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef, useState } from "react";
const SAFE_URL_PROTOCOLS = new Set(["https:", "http:", "ipfs:", "ar:"]);
const CONFIRM_RESET_MS = 2500;
function getSafeUrl(rawUrl: string): string | null {
  try {
    const parsed = new URL(rawUrl);
    if (SAFE_URL_PROTOCOLS.has(parsed.protocol)) {
      return parsed.toString();
    }
  } catch {
    return null;
  }
  return null;
}
function getLinkLabel(mediaUrl: string): string {
  const fileInfo = getFileInfoFromUrl(mediaUrl);
  if (fileInfo) {
    return `${fileInfo.name}.${fileInfo.extension}`;
  }
  return mediaUrl;
}
export default function UnsupportedMediaLink(t0) {
  const $ = _c(25);
  const {
    media_url,
    disableMediaInteraction: t1
  } = t0;
  const disableMediaInteraction = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== media_url) {
    t2 = getSafeUrl(media_url);
    $[0] = media_url;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const safeUrl = t2;
  let t3;
  if ($[2] !== media_url) {
    t3 = getLinkLabel(media_url);
    $[2] = media_url;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const label = t3;
  const [confirmOpen, setConfirmOpen] = useState(false);
  const confirmResetTimeoutRef = useRef(null);
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      if (confirmResetTimeoutRef.current !== null) {
        globalThis.window.clearTimeout(confirmResetTimeoutRef.current);
      }
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      if (confirmResetTimeoutRef.current !== null) {
        globalThis.window.clearTimeout(confirmResetTimeoutRef.current);
      }
      confirmResetTimeoutRef.current = globalThis.window.setTimeout(() => {
        setConfirmOpen(false);
        confirmResetTimeoutRef.current = null;
      }, CONFIRM_RESET_MS);
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const scheduleConfirmReset = t6;
  let t7;
  if ($[7] !== confirmOpen || $[8] !== safeUrl) {
    t7 = () => {
      if (!safeUrl) {
        return;
      }
      if (!confirmOpen) {
        setConfirmOpen(true);
        scheduleConfirmReset();
        return;
      }
      if (confirmResetTimeoutRef.current !== null) {
        globalThis.window.clearTimeout(confirmResetTimeoutRef.current);
        confirmResetTimeoutRef.current = null;
      }
      setConfirmOpen(false);
      globalThis.window.open(safeUrl, "_blank", "noopener,noreferrer");
    };
    $[7] = confirmOpen;
    $[8] = safeUrl;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleOpen = t7;
  if (!safeUrl || disableMediaInteraction) {
    let t8;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ExclamationTriangleIcon className="tw-size-5 tw-flex-shrink-0" />;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] !== label) {
      t9 = <span className="tw-inline-flex tw-w-full tw-items-center tw-gap-x-4 tw-rounded-md tw-border tw-border-solid tw-border-amber-700/60 tw-bg-amber-950/25 tw-px-4 tw-py-3 tw-text-amber-200">{t8}<span className="tw-min-w-0 tw-break-all tw-text-sm">{label}</span></span>;
      $[11] = label;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    return t9;
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ExclamationTriangleIcon className="tw-size-5 tw-flex-shrink-0 tw-text-amber-300" />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = confirmOpen ? "Open anyway \u2014 may be unsafe" : "Unknown file";
  let t10;
  if ($[14] !== t9) {
    t10 = <span className="tw-block tw-text-[9px] tw-font-semibold tw-uppercase tw-tracking-[0.14em] tw-text-amber-400">{t9}</span>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== label) {
    t11 = <span className="tw-block tw-break-all tw-text-[13px] tw-font-medium tw-text-amber-100">{label}</span>;
    $[16] = label;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <span className="tw-min-w-0 tw-flex-1">{t10}{t11}</span>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ArrowTopRightOnSquareIcon className="tw-size-5 tw-flex-shrink-0 tw-text-amber-300" />;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== handleOpen || $[23] !== t12) {
    t14 = <button type="button" onClick={handleOpen} className="tw-inline-flex tw-w-full tw-items-center tw-gap-x-4 tw-rounded-md tw-border tw-border-solid tw-border-amber-700/60 tw-bg-amber-950/25 tw-px-4 tw-py-3 tw-text-left tw-transition desktop-hover:hover:tw-border-amber-500/80 desktop-hover:hover:tw-bg-amber-950/40">{t8}{t12}{t13}</button>;
    $[22] = handleOpen;
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}